/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';

import useStyles from './styles';

const NumOfOpportunities = ({ numOfOpportunities, isMapPage }) => {
  const styles = useStyles();
  return (
    <div css={styles.numOfOppContainer(numOfOpportunities, isMapPage)}>
      <p css={styles.numOfOppText(isMapPage)}>
        Showing {numOfOpportunities} opportunities
      </p>
    </div>
  );
};

NumOfOpportunities.propTypes = {
  numOfOpportunities: PropTypes.number,
};
export default NumOfOpportunities;
